export function hostnameToUrl(hostname: string | undefined): string | null {
  if (!hostname?.trim()) return null;
  const h = hostname.trim();
  if (/^https?:\/\//i.test(h)) return h;
  return `https://${h}`;
}

function withCacheBust(url: string, cacheBust?: string | number): string {
  if (cacheBust === undefined || cacheBust === '') return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${encodeURIComponent(String(cacheBust))}`;
}

export function PreviewLink({
  hostname,
  cacheBust,
}: {
  hostname?: string;
  cacheBust?: string | number;
}) {
  const url = hostnameToUrl(hostname);
  if (!url) {
    return <span className="text-sm text-nm-muted">No preview yet</span>;
  }
  const href = withCacheBust(url, cacheBust);
  const display = url.replace(/^https:\/\//, '');
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-2">
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="truncate font-mono text-sm text-nm-accent hover:underline"
      >
        {display}
      </a>
      <button
        type="button"
        onClick={() => void navigator.clipboard.writeText(href)}
        className="fp-btn fp-btn-ghost !px-3 !py-1"
      >
        Copy
      </button>
      <a href={href} target="_blank" rel="noreferrer" className="fp-btn fp-btn-ghost !px-3 !py-1">
        Open
      </a>
    </div>
  );
}
